import type { Dispatcher } from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import type { CreateMessageParams } from 'bundles/enterprise-admin-messages/types';
import type { CreateSkillsMessageParams } from 'bundles/enterprise-admin-skills/utils/apiTypes';

class CreateMessageParamsStore extends BaseStore {
  static storeName = 'CreateMessageParamsStore';

  static handlers = {
    UPDATE_CREATE_MESSAGE_PARAMS: 'onUpdateCreateMessageParams',
    CLEAR_CREATE_MESSAGE_PARAMS: 'onClearCreateMessageParams',
    UPDATE_CREATE_SKILLS_MESSAGE_PARAMS: 'onUpdateCreateSkillsMessageParams',
    CLEAR_CREATE_SKILLS_MESSAGE_PARAMS: 'onClearCreateSkillsMessageParams',
    RESET_PARAMS: 'reset',
  };

  declare params?: CreateMessageParams;

  declare skillsParams?: CreateSkillsMessageParams;

  constructor(dispatcher: Dispatcher) {
    super(dispatcher);
    this.params = undefined;
    this.skillsParams = undefined;
  }

  reset() {
    this.params = undefined;
    this.skillsParams = undefined;
  }

  getParams() {
    return this.params;
  }

  getSkillParams() {
    return this.skillsParams;
  }

  onUpdateCreateSkillsMessageParams(payload: { params: CreateSkillsMessageParams }) {
    this.skillsParams = payload.params;
    this.params = undefined;
    this.emitChange();
  }

  onClearCreateSkillsMessageParams() {
    this.skillsParams = undefined;
    this.emitChange();
  }

  onUpdateCreateMessageParams(payload: { params: CreateMessageParams }) {
    this.params = payload.params;
    this.skillsParams = undefined;
    this.emitChange();
  }

  onClearCreateMessageParams() {
    this.params = undefined;
    this.emitChange();
  }
}

export default CreateMessageParamsStore;
